<template>
    <div class="" style="width: 400px; max-width:90vw;">
      <q-bar :dark="dark" class="bg-primary" :style="{ color: textColor }">
        <q-icon name="security" />
        <div v-if="login"> Login </div>
        <div v-else> Register </div>
        <q-space />

        <q-btn dense flat :label="login ? 'Register' : 'Login'" @click="login = !login" :style="{ color: textColor }" />
      </q-bar>

      <q-card-section class="q-pa-none">
        <LoginForm v-if="login"/>
        <RegisterForm v-else />
      </q-card-section>

      <q-separator v-if="!$q.screen.xs" :dark="dark" />

      <q-card-actions :dark="dark" class="bg-primary">
          <q-btn flat square :dark="dark" class="full-width" label="login"  text-color="textColor" color="primary" /> 
      </q-card-actions>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'
const { brightness } = colors

export default {

  name: 'BaseAuthIndexForm',

  components: {
    LoginForm: () => import('components/auth/forms/login'),
    RegisterForm: () => import('components/auth/forms/register'),
  },

  data() {
    return {
      login: true,
    }
  },

  created() {

  },

  computed: {

    ...mapGetters("merchants", { getMerchantInStore: "get" }),
    merchant() { return this.getMerchantInStore(this.$store.state.ids.merchant_id) },

    ...mapGetters("merchant-settings", { getMerchantSettingsInStore: "get" }),
    settings() { return this.getMerchantSettingsInStore(this.merchant.settings_id) },

    pageStyle() {
      return {
        backgroundColor: this.$store.state.config.launch.background_color,
        color: this.textColor,
      }
    },

    dark() {
      if (this.$store.state.config.dark_mode) return true
      else return false
    },

    textColor() {
      if (brightness(this.$store.state.config.launch.background_color) > 128) return "#566573"
      else return '#fafafa'
    },

  },

  methods: {
    submit() {

    }
  },
}
</script>

<style>

</style>